const getters = {
  loaded: state => state.load,
  sound: state => state.sound,
};

export default getters;
